import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';

export const BOT_ROUTES = { CONFIG: '/marketing/assistente' } as const;

const ENDPOINT = '/api/v1/bot/config';

export interface BotConfig {
  enabled: boolean;
  /** "Consultar preco" no menu do assistente. */
  priceMenu: boolean;
  /** "Falar com um atendente" no menu do assistente. */
  humanMenu: boolean;
  welcome: string;
  handoffReply: string;
  offHoursReply: string | null;
  /** O menu ja montado, do jeito que o cliente recebe. */
  preview: string;
}

export function useBotConfig() {
  return useQuery({
    queryKey: ['bot-config'],
    queryFn: () => apiClient.get<BotConfig>(ENDPOINT),
  });
}

export function useSaveBotConfig() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: Partial<Omit<BotConfig, 'preview'>>) =>
      apiClient.patch<BotConfig>(ENDPOINT, input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['bot-config'] }),
  });
}

/** Assume a conversa ou devolve para o assistente. */
export function useSetHandling(conversationId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (byHuman: boolean) =>
      apiClient.patch<{ handledByHuman: boolean }>(
        `/api/v1/conversations/${conversationId}/handling`,
        { byHuman },
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['conversations'] });
      queryClient.invalidateQueries({ queryKey: ['conversation', conversationId] });
    },
  });
}
